// extracted by mini-css-extract-plugin
export var button = "_k6-0";
export var donut = "_k6-1";
export var donutFill = "_k6-3";
export var donutTrack = "_k6-2";